// extracted by mini-css-extract-plugin
export default {"wrapper":"Hint_wrapper__Lkv05"};